import React, { Component } from "react";
import { connect } from "react-redux";
import MergeCmsActions from "./appRedux/reducers/MergeCmsRedux";
import routes from "../src/routes";
import {
  withRouter,
  Route,
  Switch,
  Redirect,
  BrowserRouter as Router,
} from "react-router-dom";

import "./assets/css/pe-icon-7.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "./assets/scss/themes.scss";

import LoadingOverlay from "./component/Loading";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    AOS.init();
    this.props.mergeCmsDataRequest();
  }

  render() {
    const { fetching, payload } = this.props;

    if (fetching || payload === null) {
      return (
        <div style={{ width: '100vw', height: '100vh', backgroundColor: 'white' }}>
          <LoadingOverlay />
        </div>
      );
    }

    return (
      <React.Fragment>
        <Router>
          <Switch>
            {routes.map((route, idx) => (
              <Route path={route.path} component={route.component} key={idx} />
            ))}
            <Route exact path="/" render={() => <Redirect to="/beranda" />} />
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ mergeCms }) => ({
  fetching: mergeCms.fetching,
  payload: mergeCms.payload,
});

const mapDispatchToProps = {
  mergeCmsDataRequest: MergeCmsActions.mergeCmsDataRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
